export default __webpack_public_path__ + "static/media/room2_3.9d63ffe0.jpg";